import { useTranslation } from 'react-i18next';
import OrdersTableContainer from '../../../modules/vehicles/components/OrdersTableContainer';
import SingleVehicleInfo from '../../../modules/vehicles/components/SingleVehicleInfo';
import useFormsIntegrationHelpers from '../../../hooks/useFormsIntegrationHelpers';
import { useParams } from 'react-router-dom';
import TableSkeleton from '../../../components/loaders/TableSkeleton';
import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import SectionHeader from '../../../components/SectionHeader';

const SingleVehicle = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const { apiData, getDataLoading } = useFormsIntegrationHelpers({
    queryKey: ['vehicles', id],
    id,
    singleGetApi: `/admin/vehicles/${id}`,
    editApi: `/admin/vehicles/${id}`,
    itemName: t('vehicle'),
    listRoute: '/vehicles'
  });

  const dispatch = useDispatch();
  dispatch(
    setBreadCrumbsData({
      page_title: `${t('vehicle_details')}${apiData?.chassis ? ` - ${apiData?.chassis}` : ''}`
    })
  );

  const tableHeaders = [{ label: t('id') }, { label: t('date') }, { label: t('amount') }, { label: t('status') }];

  if (getDataLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="single-vehicle-page-container">
      <SectionHeader title={t("main_information")}>
        <SingleVehicleInfo data={apiData} />
      </SectionHeader>
      <SectionHeader title={t("vehicle_orders")}>
        <OrdersTableContainer tableHeaders={tableHeaders} data={apiData?.orders} noDataMessage={t('no_orders_found')} lessColumns />
      </SectionHeader>
    </div>
  );
};

export default SingleVehicle;
